// styles and images
import "./Project.css";
import Edit from "../../assets/edit.svg";
import Delete from "../../assets/delete.svg";

//store
import { projectStore } from "../../store/Store";
import { useState } from "react";
import { useEffect } from "react";

export default function CreditDebitCard({
  setEditTrigger,
  setDeleteTrigger,
  setEditId,
  setDeleteFields
}) {
  // global
  const projectCreditsDebits = projectStore(
    (data) => data.projectCreditsDebits
  );
  const setProjectCreditsDebits = projectStore(
    (data) => data.setProjectCreditsDebits
  );
  const setProjectTotals = projectStore((data) => data.setProjectTotals);
  const currentProject = projectStore((data) => data.currentProject);
  const projectCustomerInvoices = projectStore(
    (data) => data.projectCustomerInvoices
  );
  const projectVendorInvoices = projectStore(
    (data) => data.projectVendorInvoices
  );

  // local
  const [customerExists, setCustomerExists] = useState(false);
  const [vendorExists, setVendorExists] = useState(false);

  const handleEdit = (id) => {
    setEditTrigger(true);
    setEditId(id);
  };

  const handleDelete = (id) => {
    setDeleteTrigger(true);
    setEditId(id)
    setDeleteFields({
      setTrigger: setDeleteTrigger,
      id: id,
      table: "project_credit_debit_tbl",
      endpoint: "credits-debits",
      nameField: "",
      setStates: [setProjectCreditsDebits, setProjectTotals],
      setStateFields: ["credits_debits", "all_totals"]
    });
  };

  const getInvoiceName = (invId, isVendor) => {
    var name;
    if (!isVendor) {
      if (projectCustomerInvoices) {
        name = projectCustomerInvoices.filter((x) => x.id === invId);
      } else return "";
    } else {
      if (projectVendorInvoices.invoices) {
        name = projectVendorInvoices.invoices.filter((x) => x.id === invId);
      } else return "";
    }
    if (name.length > 0) {
      return name[0].invoice_name;
    } else {
      return "";
    }
  };

  useEffect(() => {
    if (projectCreditsDebits) {
      const customer = projectCreditsDebits.filter((x) => !x.is_vendor);
      const vendor = projectCreditsDebits.filter((x) => x.is_vendor);
      if (customer.length > 0) {
        setCustomerExists(true);
      }
      if (vendor.length > 0) {
        setVendorExists(true);
      }
    }
  }, [projectCreditsDebits]);

  return (
    projectCreditsDebits && (
      <div className="col-auto">
        <div className="p-2 border text-center project-card">
          <div className="d-flex justify-content-between project-header">
            <h5>Credits and Charges</h5>
          </div>
          {customerExists && (
            <div className="project-card-list">
              <h6>Customer</h6>
              <table className="table table-sm table-hover">
                <thead>
                  <tr>
                    <th>Invoice</th>
                    <th>Amount $</th>
                    <th>Type</th>
                    {!currentProject.project.archived && <th>Action</th>}
                  </tr>
                </thead>
                <tbody>
                  {projectCreditsDebits.map(
                    (cd, idx) =>
                      !cd.is_vendor && (
                        <tr key={idx}>
                          <td>{getInvoiceName(cd.invoice_id, cd.is_vendor)}</td>
                          <td>{cd.amount}</td>
                          <td>
                            {!cd.is_credit
                              ? "Additional Charge to Customer"
                              : "Credit to Customer"}
                          </td>
                          {!currentProject.project.archived && (
                            <td className="action">
                              <div className="d-flex justify-content-between">
                                <img
                                  src={Edit}
                                  className="edit"
                                  onClick={() => handleEdit(cd.id)}
                                  alt="edit"
                                />
                                <img
                                  src={Delete}
                                  className="edit"
                                  onClick={() => handleDelete(cd.id)}
                                  alt="delete"
                                />
                              </div>
                            </td>
                          )}
                        </tr>
                      )
                  )}
                </tbody>
              </table>
            </div>
          )}
          {vendorExists && (
            <div className="project-card-list">
              <h6>Vendor</h6>
              <table className="table table-sm table-hover">
                <thead>
                  <tr>
                    <th>Vendor</th>
                    <th>Record Type</th>
                    <th>Invoice</th>
                    <th>Amount $</th>
                    <td>Type</td>
                    {!currentProject.project.archived && <th>Action</th>}
                  </tr>
                </thead>
                <tbody>
                  {projectCreditsDebits.map(
                    (cd, idx) =>
                      cd.is_vendor && (
                        <tr key={idx}>
                          <td>{cd.vendor_name}</td>
                          <td>
                            {cd.is_credit
                              ? "Credit Issued to Us"
                              : "Charge to Us"}
                          </td>
                          <td>{getInvoiceName(cd.invoice_id, cd.is_vendor)}</td>
                          <td>
                            {cd.amount.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </td>
                          <td>{cd.invoice_type}</td>
                          {!currentProject.project.archived && (
                            <td className="action">
                              <div className="d-flex justify-content-between">
                                <img
                                  src={Edit}
                                  className="edit"
                                  onClick={() => handleEdit(cd.id)}
                                  alt="edit"
                                />
                                <img
                                  src={Delete}
                                  className="edit"
                                  onClick={() => handleDelete(cd.id)}
                                  alt="delete"
                                />
                              </div>
                            </td>
                          )}
                        </tr>
                      )
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    )
  );
}
